var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: "HCP Request From iDoctor" } },
            [
              _c("el-input", {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: _vm.onSearch,
                    expression: "onSearch",
                  },
                ],
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search",
                  clearable: "",
                },
                on: { clear: _vm.onSearch },
                model: {
                  value: _vm.searchVal,
                  callback: function ($$v) {
                    _vm.searchVal = $$v
                  },
                  expression: "searchVal",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "SeTable",
              attrs: {
                data: _vm.tableData,
                "element-loading-text": "Loading...",
              },
              on: { "sort-change": _vm.onSortChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand", width: "20px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "table-expand-wrapper" },
                          [
                            _c(
                              "el-row",
                              {
                                attrs: {
                                  type: "flex",
                                  justify: "space-around",
                                },
                              },
                              [
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Doctor Email")]),
                                  _c("p", [_vm._v(_vm._s(row.DoctorEmail))]),
                                ]),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Doctor Phone")]),
                                  _c("p", [_vm._v(_vm._s(row.Phone))]),
                                ]),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Rep ID")]),
                                  _c("p", [_vm._v(_vm._s(row.SrId))]),
                                ]),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Type")]),
                                  _c("p", [_vm._v(_vm._s(row.RequestType))]),
                                ]),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Reject Reason")]),
                                  _c("p", [
                                    _vm._v(_vm._s(row.MainRejectReason)),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              {
                                attrs: {
                                  type: "flex",
                                  justify: "space-around",
                                },
                              },
                              [
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Hospital / Institution")]),
                                  _c("p", [_vm._v(_vm._s(row.Hospital))]),
                                ]),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Department")]),
                                  _c("p", [_vm._v(_vm._s(row.Department))]),
                                ]),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Rep Name")]),
                                  _c("p", [_vm._v(_vm._s(row.SrName))]),
                                ]),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("Product Info")]),
                                  _c("p", [_vm._v(_vm._s(row.ProdInfo))]),
                                ]),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("TA")]),
                                  _c("p", [_vm._v(_vm._s(row.TA))]),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Id",
                  label: "Id",
                  sortable: "custom",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Title",
                  label: "Title",
                  sortable: "custom",
                  "min-width": "185",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "DoctorName",
                  label: "Doctor Name",
                  width: "145",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "TimeSlot",
                  label: "Time Slot",
                  sortable: "custom",
                  width: "150",
                  formatter: _vm.dateFormatter,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "QuestionInfo",
                  label: "Question From Doctor",
                  sortable: "custom",
                  "min-width": "230",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CreateDt",
                  label: "Receive Request Time",
                  sortable: "custom",
                  width: "205",
                  formatter: _vm.dateFormatter,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Operation",
                  width: "125",
                  sortable: "custom",
                  prop: "StatusDesc",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.Status == 0
                          ? _c(
                              "OptionMenu",
                              {
                                attrs: {
                                  icon: "iconfont icon-more-menu",
                                  iconSize: "18",
                                },
                              },
                              [
                                _c("OptionMenuItem", {
                                  attrs: {
                                    icon: "iconfont icon-approve",
                                    title: "Approve",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleApproved(row)
                                    },
                                  },
                                }),
                                _c("OptionMenuItem", {
                                  attrs: {
                                    icon: "el-icon-remove-outline",
                                    title: "Reject",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleReject(row)
                                    },
                                  },
                                }),
                                _c("OptionMenuItem", {
                                  attrs: {
                                    icon: "iconfont icon-share",
                                    title: "Forward",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleForward(row)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _c("span", {
                              domProps: { textContent: _vm._s(row.StatusDesc) },
                            }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 25, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ForwardRequestDialog", {
        attrs: { visible: _vm.forwardRequestDialogVisible, data: _vm.editRow },
        on: {
          "update:visible": function ($event) {
            _vm.forwardRequestDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.editRow = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("RejectRequestDialog", {
        attrs: { visible: _vm.rejectDialogVisible, data: _vm.editRow },
        on: {
          "update:visible": function ($event) {
            _vm.rejectDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.editRow = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("ApprovedRequestDialog", {
        attrs: {
          visible: _vm.approvedDialogVisible,
          data: _vm.editRow,
          status: _vm.forwardStatus,
        },
        on: {
          "update:visible": function ($event) {
            _vm.approvedDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.editRow = $event
          },
          "update:status": function ($event) {
            _vm.forwardStatus = $event
          },
          success: _vm.onSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }